// @flow

import {createDatabase} from '@gob/web-database'

export const db = createDatabase()
